import React from 'react';

import PropTypes from 'prop-types';

import { StyledGradientButton } from './styles';
import { bemClassName } from '../../../utils/bem';
import { LoadingIndicator } from '../../atoms/loading-indicator';

const b = bemClassName('gradient-button');

const GradientButton = (props) => {
  const {
    children,
    variant,
    active,
    onClick,
    type = 'button',
    loading,
    width = 'fit-content',
    disabled = false,
  } = props;

  return (
    <StyledGradientButton width={width}>
      <button className={b({ variant, active })} onClick={onClick} type={type} disabled={disabled || loading}>
        {children}
        {loading && (
          <div className={b('icon')}>
            <LoadingIndicator size={16} />
          </div>
        )}
      </button>
    </StyledGradientButton>
  );
};

GradientButton.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.string,
  active: PropTypes.bool,
  onClick: PropTypes.func,
  type: PropTypes.string,
  loading: PropTypes.bool,
  width: PropTypes.any,
  disabled: PropTypes.bool,
};

export default GradientButton;
